import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ChevronLeft, Award } from 'lucide-react';
import Logo from '../components/Logo';

const ChartePage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Logo size="small" linkTo="/" />
            <Link to="/register">
              <Button variant="outline" size="sm">
                <ChevronLeft className="h-4 w-4 mr-1" />
                Retour
              </Button>
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-8 md:p-12">
          {/* Title */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#00B050]/10 rounded-2xl mb-4">
              <Award className="h-8 w-8 text-[#00B050]" />
            </div>
            <h1 className="text-3xl font-bold text-slate-900 mb-2">CHARTE DE QUALITÉ ET DE FONCTIONNEMENT</h1>
            <p className="text-xl font-semibold text-[#00B050]">CLUB 10 MILLIONS INVESTOR</p>
          </div>

          {/* Sections */}
          <div className="space-y-8 text-slate-700 text-sm leading-relaxed">
            
            {/* OBJET */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-4 border-b pb-2">OBJET</h2>
              <p className="mb-3">
                Le Club 10 MILLIONS Investor a pour vocation de réunir des professionnels de l'immobilier et de l'investissement partageant une même exigence de qualité, de sérieux, de transparence et d'engagement, au service des membres et clients particuliers du Club.
              </p>
              <p className="mb-3">
                La présente charte a pour objet de définir les principes, valeurs et règles de fonctionnement applicables aux partenaires professionnels et aux membres particuliers intervenant au sein du Club. Elle constitue un cadre de référence commun, destiné à garantir un haut niveau de professionnalisme, un engagement de qualité et à préserver l'image, les principes éthiques, la crédibilité et la cohésion du Club.
              </p>
              <p>
                La charte ne constitue ni une certification, ni une garantie, ni un engagement de résultat de la part du Club concernant les prestations, conseils ou opérations réalisés par les partenaires. Le Club intervient exclusivement en qualité d'animateur de réseau et de facilitateur de mise en relation.
              </p>
            </section>

            {/* ARTICLE 1 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-4 border-b pb-2">ARTICLE 1 – PROFESSIONNALISME ET COMPÉTENCE</h2>
              <p>
                Le partenaire s'engage à proposer des prestations professionnelles, qualitatives, fiables et conformes à ses compétences, qualifications et autorisations réelles. Il s'interdit toute présentation trompeuse de son expertise ou de ses capacités.
              </p>
            </section>

            {/* ARTICLE 2 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-4 border-b pb-2">ARTICLE 2 – PARTICIPATION EN QUALITÉ DE PARTICULIER – ESPRIT ET RÈGLES DE CONDUITE</h2>
              <p className="mb-3">
                Le Club accueille des membres intervenant soit à titre professionnel, soit à titre strictement personnel.
              </p>
              <p className="mb-3">
                Lorsqu'un membre participe aux activités du Club en qualité de particulier, il s'engage à ne pas faire état de son activité professionnelle ni à en tirer un quelconque avantage.
              </p>
              <p className="mb-3">
                À ce titre, il s'interdit notamment toute démarche de promotion, de prospection ou de mise en relation à finalité commerciale, directe ou indirecte.
              </p>
              <p className="mb-3">
                Les échanges doivent demeurer désintéressés et conformes à l'esprit du Club, fondé sur la qualité des relations humaines et le respect des autres membres.
              </p>
              <p>
                Tout comportement contraire à ces principes pourra donner lieu à un rappel des règles, voire à une exclusion du Club dans les conditions prévues par son règlement.
              </p>
            </section>

            {/* ARTICLE 3 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-4 border-b pb-2">ARTICLE 3 – ÉTHIQUE ET DÉONTOLOGIE</h2>
              <p className="mb-3">
                Le Club a vocation à favoriser des échanges de qualité entre professionnels et particuliers, dans un esprit de confiance et de respect mutuel.
              </p>
              <p className="mb-3">
                Le partenaire s'engage à respecter les règles d'éthique, de déontologie et les bonnes pratiques applicables à sa profession. Il fournit aux membres du Club des informations claires, et objectives, dans un esprit d'intégrité et de transparence dans le respect de l'intérêt des clients.
              </p>
              <p>
                Le membre, lorsqu'il intervient en qualité de particulier, s'engage à adopter un comportement respectueux, loyal et de bonne foi à l'égard des partenaires et des autres membres du Club. Il s'interdit tout comportement abusif, dénigrant ou contraire à l'esprit du Club.
              </p>
            </section>

            {/* ARTICLE 3 bis - CONFORMITÉ */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-4 border-b pb-2">ARTICLE 3 bis – CONFORMITÉ LÉGALE ET RÉGLEMENTAIRE</h2>
              <p>
                Le partenaire déclare exercer son activité dans le strict respect des lois et réglementations en vigueur, notamment en matière de droit de la consommation, de protection des données personnelles, de transparence et, le cas échéant, de règles professionnelles spécifiques. Il déclare disposer de l'ensemble des assurances, autorisations et habilitations nécessaires à l'exercice de son activité.
              </p>
            </section>

            {/* ARTICLE 4 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-4 border-b pb-2">ARTICLE 4 – TRANSPARENCE TARIFAIRE</h2>
              <p>
                Le partenaire s'engage à communiquer de manière claire et préalable ses conditions tarifaires aux membres du Club. Il s'engage à respecter les conditions préférentielles accordées aux membres du Club lorsqu'elles sont prévues.
              </p>
            </section>

            {/* ARTICLE 5 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-4 border-b pb-2">ARTICLE 5 – QUALITÉ DES PRESTATIONS, INTERVENTIONS ET FORMATIONS</h2>
              <p>
                Les prestations proposées par les partenaires sont adaptées au public du Club. Le partenaire s'engage à intervenir dans un cadre professionnel, respectueux, constructif et dans le respect des délais annoncés.
              </p>
            </section>

            {/* ARTICLE 6 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-4 border-b pb-2">ARTICLE 6 – DISPONIBILITÉ, ÉCOUTE ET SUIVI</h2>
              <p className="mb-3">
                Le partenaire fait preuve de disponibilité, d'écoute et de réactivité dans ses échanges avec les membres du Club. Il assure un suivi sérieux et diligent des relations engagées avec les membres.
              </p>
              <p className="mb-3">
                Les membres s'engagent à communiquer l'ensemble des informations et documents utiles permettant aux partenaires de répondre de manière pertinente à leurs demandes.
              </p>
              <p>
                Le sérieux et la qualité des relations au sein du Club reposent sur un engagement réciproque entre les membres et les partenaires.
              </p>
            </section>

            {/* ARTICLE 7 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-4 border-b pb-2">ARTICLE 7 – CONFIDENTIALITÉ ET PROTECTION DES DONNÉES</h2>
              <p>
                Le partenaire ou le membre s'engage à respecter strictement la confidentialité des échanges, informations et données obtenus dans le cadre du Club. Il s'interdit toute utilisation ou divulgation à des fins étrangères à la relation professionnelle avec les partenaires ou les membres, dans le respect des règles applicables en matière de protection des données personnelles pendant et après la durée du partenariat.
              </p>
            </section>

            {/* ARTICLE 8 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-4 border-b pb-2">ARTICLE 8 – LOYAUTÉ, INDÉPENDANCE ET CONFLITS D'INTÉRÊTS</h2>
              <p>
                Le partenaire ou le membre adopte un comportement loyal à l'égard du Club, des autres partenaires et des membres. Il s'interdit toute pratique de concurrence déloyale, de dénigrement ou de détournement de membres. Toute situation de conflit d'intérêts susceptible d'affecter la relation avec le Club ou les partenaires ou les membres devra être portée à la connaissance du Club.
              </p>
            </section>

            {/* ARTICLE 9 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-4 border-b pb-2">ARTICLE 9 – PARTICIPATION À LA VIE DU CLUB</h2>
              <p>
                Le partenaire s'engage à participer activement à la vie du Club, notamment en prenant part aux événements, rencontres et actions collectives, et en contribuant, par son expertise à l'enrichissement de la communauté.
              </p>
            </section>

            {/* ARTICLE 10 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-4 border-b pb-2">ARTICLE 10 – IMAGE ET RÉPUTATION DU CLUB</h2>
              <p>
                Le partenaire ou le membre s'engage à adopter en toutes circonstances un comportement compatible avec l'image, les valeurs et la réputation du Club. Il s'interdit tout agissement ou communication susceptible de porter atteinte au Club ou à ses partenaires ou à ses membres.
              </p>
            </section>

            {/* ARTICLE 11 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-4 border-b pb-2">ARTICLE 11 – MANQUEMENTS ET SANCTIONS</h2>
              <p>
                Tout manquement à la présente charte constitue un manquement aux obligations du partenaire ou du membre. Selon la gravité des faits constatés, le Club pourra prononcer un rappel à l'ordre, une suspension temporaire ou une exclusion du Club, sans préjudice des stipulations contractuelles applicables et de toute autre action que le Club serait fondé à engager.
              </p>
            </section>

            {/* ARTICLE 12 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-4 border-b pb-2">ARTICLE 12 – ÉVOLUTION DE LA CHARTE</h2>
              <p>
                La présente charte est susceptible d'évoluer afin de s'adapter aux évolutions du Club, de son fonctionnement ou du cadre réglementaire. La version en vigueur est celle mise à disposition par le Club. Le maintien de la qualité de partenaire vaut acceptation de la charte dans sa version actualisée.
              </p>
            </section>

            {/* ARTICLE 13 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-4 border-b pb-2">ARTICLE 13 – ACCEPTATION</h2>
              <p>
                La signature de la présente charte emporte adhésion pleine et entière à l'ensemble de ses stipulations.
              </p>
            </section>

            {/* ARTICLE 14 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-4 border-b pb-2">ARTICLE 14 – SIGNATURE ÉLECTRONIQUE ET CONVENTION DE PREUVE</h2>
              <p className="mb-3">
                Conformément aux articles 1366 et 1367 du Code civil, les Parties conviennent expressément que la présente charte pourra être acceptée et signée par voie électronique et acceptent, à cette fin, le recours à un procédé de signature électronique mis en œuvre par un prestataire spécialisé.
              </p>
              <p className="mb-3">
                Les Parties reconnaissent avoir été dûment informées des modalités de la signature électronique et acceptent que celle-ci produise les mêmes effets juridiques et dispose de la même force probante qu'une signature manuscrite apposée sur un support papier, traduisant valablement leur consentement et leur intention d'être juridiquement liées par la présente charte.
              </p>
              <p className="mb-3">
                Conformément à l'article 1368 du Code civil, les Parties conviennent que les éléments relatifs à la signature électronique, et notamment les données d'identification, certificats, fichiers de preuve, signatures électroniques et marques de temps générés dans le cadre du processus de signature, constituent des moyens de preuve recevables entre elles et pourront être valablement produits en justice en cas de litige.
              </p>
              <p className="mb-3">
                Les Parties reconnaissent la valeur juridique et la force probante des documents établis, acceptés, signés et conservés par l'intermédiaire de la plateforme de signature électronique utilisée, ainsi que des enregistrements et éléments d'archivage effectués par le prestataire de services de signature et d'archivage électronique.
              </p>
              <p>
                La présente convention de preuve est conclue pour la durée d'application de la charte et demeure applicable jusqu'à preuve contraire rapportée par l'une ou l'autre des Parties.
              </p>
            </section>

          </div>

          {/* Footer */}
          <div className="mt-12 pt-8 border-t border-slate-200 text-center">
            <p className="text-sm text-slate-500 mb-4">
              En rejoignant le Club, vous acceptez la présente Charte de Qualité et de Fonctionnement.
            </p>
            <Link to="/register">
              <Button className="bg-[#00B050] hover:bg-[#009040]">
                Créer mon compte
              </Button>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ChartePage;
